import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Store} from '@ngxs/store';
import {ValidatableFormComponent} from '../validatable-form';
import {PasswordChangeState} from '../../../../state/password-change/password-change.state';
import {PasswordPolicy} from '../../../../models/password-policy.model';

@Component({
    selector: 'app-password-change-form',
    templateUrl: './password-change-form.component.html',
})
export class PasswordChangeFormComponent extends ValidatableFormComponent implements OnInit, OnDestroy {
    @Input() passwordPolicy: PasswordPolicy;
    @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();

    protected errors: {};

    formGroup: FormGroup;

    constructor(private store: Store) {
        super(store.select(PasswordChangeState.passwordChangeFormErrors));
    }

    ngOnInit(): void {
        this.formGroup = new FormGroup({
            oldPassword: this.createFormControl('', 'oldPassword'),
            password: this.createFormControl('', 'password'),
            passwordConfirmation: this.createFormControl('', 'passwordConfirmation')
        });
    }

    onSubmit() {
        this.formSubmit.emit();
    }
}
